import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useStore } from "../lib/store";
import { getTurnstileToken } from "../lib/turnstile";

export default function Login() {
  const { login } = useStore();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const turnstile_token = await getTurnstileToken();
      const user = await login(email, password, turnstile_token);
      toast.success(`Welcome back, ${user.name}`);
      nav(user.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-kv pt-32 pb-20 max-w-md mx-auto" data-testid="login-page">
      <div className="card-kv">
        <div className="overline mb-3">Welcome back</div>
        <h1 className="font-serif text-3xl mb-6 font-light">Sign in</h1>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} name="email" />
          <Field label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} name="password" />
          <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="login-submit">
            {busy ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p className="text-sm text-[#A8A5A1] mt-6 text-center">
          No account? <Link to="/register" className="text-[#C8A97E] hover:underline">Create one</Link>
        </p>
      </div>
    </div>
  );
}

function Field({ label, ...p }) {
  return (
    <div>
      <label className="text-xs text-[#75726D] uppercase tracking-widest mb-2 block">{label}</label>
      <input {...p} data-testid={`field-${p.name}`} required />
    </div>
  );
}
